import React from "react";
import Sequencing from "../../../components/Dashboard/Sequencing";
import "./style.scss";

const SequencingPage = () => {
  return (
    <div className="sequencing_page_wrapper">
      <Sequencing />
    </div>
  );
};

export default SequencingPage;
